import AuthService from './auth';
import AccountService from './account';
import PlaceService from './place';
import PlaceLikeService from './place-like';
import FileService from './file';
import FeedService from './feed';
import FeedLikeService from './like';
import FeedCommentService from './comment';
import TermsService from './terms';
import MemberService from './member';
import InquiryService from './inquiry';
import SearchService from './search';
import MapService from './maps';
import PushService from './push';
import ShortLinkService from './short-link';
import FeedButtonService from './feed-button';
import ProductService from './product';
import CommercePolicyService from './commerce-policy';
import CartService from './cart';
import OrderService from './order';
import NotificationService from './notification';
import BrandCommerceService from './brand-commerce';
import OperatorCommerceService from './operator-commerce';

const api = {
  auth: new AuthService(),
  account: new AccountService(),
  place: new PlaceService(),
  placeLike: new PlaceLikeService(),
  member: new MemberService(),
  file: new FileService(),
  feed: new FeedService(),
  feedLike: new FeedLikeService(),
  feedComment: new FeedCommentService(),
  terms: new TermsService(),
  inquiry: new InquiryService(),
  search: new SearchService(),
  maps: new MapService(),
  push: new PushService(),
  shortLink: new ShortLinkService(),
  feedButton: new FeedButtonService(),
  product: new ProductService(),
  commercePolicy: new CommercePolicyService(),
  cart: new CartService(),
  order: new OrderService(),
  notification: new NotificationService(),
  brandCommerce: new BrandCommerceService(),
  operatorCommerce: new OperatorCommerceService(),
};

export default api;
